if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.productInfo = this.productSection.querySelector('.product-info');
      this.productForm = this.productSection.querySelector('product-form');
      this.atcBlock = this.productSection.querySelector('.product-info__add-to-cart');

      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents();
      }
    }

    // eslint-disable-next-line class-methods-use-this
    disconnectedCallback() {
      window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    bindEvents() {
      const mobileTarget = this.atcBlock || this.productForm;

      if (this.productInfo) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.target === this.productInfo && theme.mediaMatches.md) {
              this.classList.toggle('sticky-atc-panel--out', entry.isIntersecting);
            }
          });
        });
        observer.observe(this.productInfo);
      }

      if (mobileTarget) {
        this.mobileScrollHandler = () => {
          if (theme.mediaMatches.md) return;
          const rect = mobileTarget.getBoundingClientRect();
          this.classList.toggle('sticky-atc-panel--out', rect.bottom > 0);
        };
        window.addEventListener('scroll', this.mobileScrollHandler, { passive: true });
        this.mobileScrollHandler();
      }

      window.addEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    /**
     * Watches for a scroll to the bottom of the page
     */
    static handleScroll() {
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      );
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}
